import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "selected"];
import React, { useContext } from 'react';
import PT from 'prop-types';
import { intrinsicComponent } from '../../utils/functions';
import DrawerContext from './drawer.context';
import Styled from './drawer.styles';
var DrawerItem = intrinsicComponent(function (_ref, ref) {
  var children = _ref.children,
    selected = _ref.selected,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(DrawerContext),
    isCollapsed = _useContext.isCollapsed;
  return /*#__PURE__*/React.createElement(Styled.Item, _extends({
    selected: selected,
    isCollapsed: isCollapsed
  }, rest, {
    ref: ref
  }), children);
});
DrawerItem.defaultProps = {
  selected: false
};
DrawerItem.propTypes = {
  selected: PT.bool
};
export default DrawerItem;